import { useMemo } from 'react';
import { avoidBreakInside } from '@provider/print';
import { textCorrectionInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { input } from './input.style.js';
import { jsx } from 'react/jsx-runtime';

function Input(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => textCorrectionInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const onChange = evt => {
    update(props.taskEntryKey, props.input.id, prev => ({
      type: "text-correction",
      validationType: "with-start-comma",
      ...prev,
      text: evt.currentTarget.innerText ?? ""
    }));
  };

  // NB: We do not want React to attempt to track and update our input once
  // the entry changes, as we want to avoid caret jumps. The source of content
  // is the input anyways.
  const initalText = useMemo(() => inputEntry?.text ?? props.input.initialText,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return /*#__PURE__*/jsx("div", {
    ref: props.ref,
    className: input,
    contentEditable: true,
    spellCheck: false,
    autoCapitalize: "none",
    autoCorrect: "off",
    suppressContentEditableWarning: true,
    onInput: onChange,
    ...avoidBreakInside(),
    children: initalText
  });
}

export { Input };
//# sourceMappingURL=input.js.map
